var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.list.length>0)?_c('div',{staticClass:"main-content clear"},_vm._l((_vm.list),function(item){return _c('ExamQuestion',{key:item.ques_id,attrs:{"ques":item,"answer":_vm.answer,"readonly":true}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }